import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('VApp', {
    class: _vm.$style.UnauthorizedLayout
  }, [_c('AppHeader', {
    attrs: {
      "authorized": false,
      "is-login-button-active": _vm.withLoginButton,
      "is-back-link-active": _vm.withBackLink
    }
  }), _vm._v(" "), _c('main', {
    class: [_vm.$style.pageWrapper, _defineProperty({}, _vm.$style.fullHeight, _vm.isFixed)]
  }, [_vm._t("default")], 2), _vm._v(" "), _vm.hasFooter ? _c('client-only', [_c('AppFooter'), _vm._v(" "), _c('ScrollUpButton')], 1) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };